import styled, { css } from 'styled-components'

interface ImageProps {
  lqip: boolean
  blurRadius: number
  transitionDuration: number
}

export const Image = styled.img<ImageProps>`
  ${({ lqip, blurRadius, transitionDuration }) => {
    return (
      lqip &&
      css`
        &:not(.ls-is-cached) {
          filter: blur(${blurRadius}px);
          transition: filter ${transitionDuration}ms;
        }

        &.lazyloaded {
          filter: blur(0);
        }
      `
    )
  }}

  &.lazyload,
  &.lazyloading,
  &.lazyloaded {
    width: 100%;
    transition: filter 50ms;
  }

  &.lazyload,
  &.lazyloading {
    filter: blur(5px);
  }
`
